import Skeleton from "@material-ui/lab/Skeleton";
import makeStyles from '@material-ui/core/styles/makeStyles';

import { GrayBoxesItem } from "../types";

interface GrayBoxesProps {
    boxes: GrayBoxesItem[];
}

const GrayBoxes: React.FC<GrayBoxesProps> = ({ boxes }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            {boxes.map((item, index) =>
                (!item || (!item.text && !item.title)) ?
                    <Skeleton key={index} className={classes.box} /> :
                    <div key={index} className={classes.box}>
                        {item.imagePath && <img className={classes.itemImg} src={item.imagePath} />}
                        <div>
                            <div className={classes.title}>{item.title}</div>
                            <div className={classes.text}>{item.text}</div>
                        </div>
                    </div>
            )}
        </div>
    )
}

export default GrayBoxes;

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        justifyContent: 'left',
        gap: '30px',
        width: '100%',
        margin: 'auto',
        marginBottom: 30,
        overflow: 'auto'
    },
    box: {
        backgroundColor: '#f5f5f5',
        padding: '20px 20px 10px 20px',
        borderRadius: '20px',
        height: '20vw',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minWidth: '20vw',
        [theme.breakpoints.down(650)]: {
            minWidth: '50vw',
            height: '50vw',
        },
        [theme.breakpoints.up(1300)]: {
            minWidth: '14vw',
            height: '14vw',
        }
    },
    title: {
        color: theme.palette.primary.main,
        marginTop: '10px',
        fontFamily: 'Assistant-bold',
        fontSize: '1.1rem',
        [theme.breakpoints.up(1600)]: {
            fontSize: '1.5rem',
        },
        [theme.breakpoints.down(600)]: {
            fontSize: '1.3rem',
        },
    },
    text: {
        color: theme.palette.primary.main,
        fontFamily: 'Assistant-regular',
        fontSize: '1rem',
        [theme.breakpoints.up(1600)]: {
            fontSize: '1.4rem',
        },
        [theme.breakpoints.down(600)]: {
            fontSize: '1rem',
        },
    },
    itemImg: {
        margin: '5px 0',
        alignSelf: 'center',
        height: '10vw',
        width: '10vw',
        maxHeight: '11vw',
        objectFit: 'contain',
        [theme.breakpoints.up(1300)]: {
            height: '12vh',
            width: '12vh',
            maxHeight: '13vw',
        },
        [theme.breakpoints.down(650)]: {
            height: '27vh',
            width: '27vh',
            maxHeight: '28vw',
        }
    }

}))